<div class="scroll-progress-container">
    <div class="scroll-progress" [style.width.%]="scrollPercentage"></div>
</div>